import { NgModule } from '@angular/core';

import { EqualToDirective } from './equal-to';
import { MinValidatorDirective } from './min/directive';
import { MaxValidatorDirective } from './max/directive';
import { EmailValidatorDirective } from './email/directive';
import { IbanValidatorDirective } from './iban/directive';
import { BicValidatorDirective } from './bic/directive';

const CUSTOM_FORM_DIRECTIVES = [
  EqualToDirective,
  MinValidatorDirective,
  MaxValidatorDirective,
  EmailValidatorDirective,
  IbanValidatorDirective,
  BicValidatorDirective
];

@NgModule({
  declarations: [ CUSTOM_FORM_DIRECTIVES ],
  exports: [ CUSTOM_FORM_DIRECTIVES ]
})
export class ValidatorsModule {}

